import React from 'react';
import Image from 'next/image';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { cn } from '@/lib/utils';
import { DashboardIcon, UserMinus } from '@/components/ui/Icons';
import { useUserStore } from '@/stores/restuarant/user';
import HeaderProfileButtonRes from './HeaderProfileButtonRes';
import useRestaurantAuth from '@/hooks/useRestaurantAuth';
import { isImpersonateRestaurant } from '@/lib/utils/functions';

export default function HeaderProfileRestaurant() {
  const user = useUserStore((state) => state.user);
  const { handleRestaurantLogout } = useRestaurantAuth();

  const removeUser = useUserStore((state) => state.removeUser);

  const logout = () => {
    handleRestaurantLogout(removeUser, isImpersonateRestaurant());
  };

  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <Menu.Button className="flex h-[50px] items-center gap-x-[14px] lg:ml-[35px] lg:w-[80px]">
            <div className="relative h-[41px] w-[41px] overflow-hidden rounded-full">
              <Image
                src={
                  user?.media?.avatar?.[0].thumb_url
                    ? user?.media?.avatar?.[0].thumb_url
                    : '/avatar.jpg'
                }
                alt={'avatar'}
                fill
              />
            </div>
            <div className="flex lg:hidden">
              {user?.first_name} {user?.last_name ?? null}
            </div>
            <svg
              width="16"
              height="8"
              viewBox="0 0 16 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={cn(
                'transfrom transition-transform delay-75 ease-in',
                open ? 'rotate-0  text-primary' : 'rotate-180 text-neutral-400'
              )}
            >
              <path
                d="M13.8337 6.68519L9.03147 1.9219C8.46434 1.35937 7.53631 1.35937 6.96918 1.9219L2.16699 6.68518"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute left-0 z-50 flex w-[206px] flex-col rounded-[15px] bg-white px-[15px] pb-[15px] pt-[15px] shadow-box lg:right-0">
              <span className="mb-[7px] break-words pl-[10px] text-h6 font-bold text-title">
                {user?.first_name} {user?.last_name}
              </span>

              <div className="">
                <Menu.Item>
                  {({ close }) => (
                    <HeaderProfileButtonRes
                      label="Dashboard"
                      icon={<DashboardIcon />}
                      path=""
                      close={close}
                    />
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ close }) => (
                    <button
                      className={cn(
                        'flex h-[35px] w-full items-center rounded-[30px] pl-[10px]'
                      )}
                      onClick={() => {
                        logout();
                        close();
                      }}
                    >
                      <UserMinus className={cn('me-[15px] text-neutral-400')} />
                      <span className="text-paragraph">Logout</span>
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
